import { render, staticRenderFns } from "./OrderNoteDialog.vue?vue&type=template&id=6f13110e&scoped=true"
import script from "./OrderNoteDialog.vue?vue&type=script&lang=js"
export * from "./OrderNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13110e",
  null
  
)

export default component.exports